import { getRuntimeConfiguration } from '../../utils/getRuntimeConfiguration.mjs';

const BASE_URL =
  getRuntimeConfiguration('WORDPRESS_API_ROOT') ?? 'https://staging.cms.babbel.news/wp-json';
const STATSIG_TEST_GROUP = 'test';
const STATSIG_CONTROL_GROUP = 'control';
const STATSIG_READY_STATUS = 'Ready';

export { BASE_URL, STATSIG_CONTROL_GROUP, STATSIG_READY_STATUS, STATSIG_TEST_GROUP };
